import { render } from "./FullTrainingView.vue?vue&type=template&id=b966f4c4&scoped=true"
import script from "./FullTrainingView.vue?vue&type=script&lang=js"
export * from "./FullTrainingView.vue?vue&type=script&lang=js"

import "./FullTrainingView.vue?vue&type=style&index=0&id=b966f4c4&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b966f4c4"]])

export default __exports__